import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  // Get campaigns list with optional filter and pagination (returns { campaigns: [], meta: { total_count } })
  getList(campaignType, page = 1, perPage = 20) {
    return axios.get(this.url, {
      params: {
        campaign_type: campaignType || undefined,
        page,
        per_page: perPage,
      },
    });
  }

  getWhatsappCampaignReport(campaignDisplayId) {
    // account scoped base is .../api/v1/accounts/:accountId/campaigns
    return axios.get(`${this.url}/${campaignDisplayId}/whatsapp_messages_report`);
  }

  getEmailCampaignReport(campaignDisplayId) {
    return axios.get(`${this.url}/${campaignDisplayId}/email_messages_report`);
  }

  getFilterOptions() {
    return axios.get(`${this.url}/filter_options`);
  }

  // Get contacts for smart_ai_email_campaign (paginated, server-side)
  getContacts(campaignDisplayId, page = 1, perPage = 20) {
    return axios.get(`${this.url}/${campaignDisplayId}/contacts`, {
      params: { page, per_page: perPage },
    });
  }

  // Get all snapshotted contact IDs for a campaign (no pagination).
  // Used by the "Select all" button to select contacts across all pages.
  getAllContactIds(campaignDisplayId) {
    return axios.get(`${this.url}/${campaignDisplayId}/contact_ids`);
  }

  // Bulk approve drafts for selected contacts
  bulkApprove(campaignDisplayId, contactIds) {
    return axios.post(`${this.url}/${campaignDisplayId}/bulk_approve`, {
      contact_ids: contactIds,
    });
  }

  // Bulk cancel drafts for selected contacts (runs in background)
  bulkCancel(campaignDisplayId, contactIds) {
    return axios.post(`${this.url}/${campaignDisplayId}/bulk_cancel`, {
      contact_ids: contactIds,
    });
  }

  // Bulk regenerate drafts for selected contacts, skip executed (runs in background)
  bulkRegenerate(campaignDisplayId, contactIds) {
    return axios.post(`${this.url}/${campaignDisplayId}/bulk_regenerate`, {
      contact_ids: contactIds,
    });
  }
}

export default new CampaignsAPI();
